export const allowedStatusesForBulkLab = new Set([
  "booked",
  "inReview",
  "readyForPickup",
  "outForPickup",
  "deliveredToLab",
  "needCorrection",
]);
export const allowedStatusesForBulkLogistics = new Set([
  "booked",
  "inReview",
  "readyForPickup",
  "outForPickup"
]);

export function getBulkLabStatus(selectedRowMap) {
    const selectedRows = [...selectedRowMap.values()];
  
    if (selectedRows.length === 0) {
      return {
        disabled: true,
        tooltip: "Please select at least one Order.",
      };
    }
  
    if (selectedRows.some((row) => row.assignedLab)) {
      return {
        disabled: true,
        tooltip: "Some selected order already assigned Lab.",
      };
    }
  
    if (
      !selectedRows.every((row) =>
        allowedStatusesForBulkLab.has(row.orderStatus?.value)
      )
    ) {
      return {
        disabled: true,
        tooltip:
          "Selected order must have status: Booked, in Review, Ready For Pickup, Out For Pickup, Delivered to Lab, needCorrection.",
      };
    }
  
    if (!selectedRows.every((row) => row.district === selectedRows[0].district)) {
      return {
        disabled: true,
        tooltip: "All selected order must belong to the same district.",
      };
    }
  
    return {
      disabled: false,
      tooltip: "",
    };
  }


  export function getBulkStatusChangeValidation(selectedRowMap, targetStatus) {
    const selectedRows = [...selectedRowMap.values()];
  
    if (selectedRows.length === 0) {
      return {
        disabled: true,
        tooltip: "Please select at least one order.",
      };
    }
  
    const firstStatus = selectedRows[0]?.orderStatus?.value;
  
    const hasDifferentStatuses = !selectedRows.every(
      (row) => row.orderStatus?.value === firstStatus
    );
  
    if (hasDifferentStatuses) {
      return {
        disabled: true,
        tooltip: "Orders with different status selected.",
      };
    }

    if (!selectedRows.every((row) => row.district === selectedRows[0].district)) {
      return {
        disabled: true,
        tooltip: "All selected order must belong to the same district.",
      };
    }
  
    switch (firstStatus + "->" + targetStatus) {
      case "pending->booked":
        if (!selectedRows.every((row) => row.samplerId)) {
          return {
            disabled: true,
            tooltip: "All orders must have a Sampler assigned.",
          };
        }
        break;
  
      case "readyForPickup->outForPickup":
        if (!selectedRows.every((row) => row.assignedLab)) {
          return {
            disabled: true,
            tooltip: "All orders must have a Lab assigned.",
          };
        }
        break;
  
      case "outForPickup->deliveredToLab":
        if (!selectedRows.every((row) => row.assignedLogistics?._id)) {
          return {
            disabled: true,
            tooltip: "All orders must have a Logistics Partner assigned.",
          };
        }
        break;
  
      case "reportUploaded->completed":
        // No additional validation needed
        break;
  
      default:
        return {
          disabled: true,
          tooltip: "This status change is not allowed.",
        };
    }
  
    return {
      disabled: false,
      tooltip: "",
    };
  }

  export function getBulkLogisticsStatus(selectedRowMap) {
    const selectedRows = [...selectedRowMap.values()];
  
    if (selectedRows.length === 0) {
      return {
        disabled: true,
        tooltip: "Please select at least one Order.",
      };
    }
  
    if (selectedRows.some((row) => row.assignedLogistics?._id)) {
      return {
        disabled: true,
        tooltip: "Some selected order already assigned Logistics.",
      };
    }
  
    if (
      !selectedRows.every((row) =>
        allowedStatusesForBulkLogistics.has(row.orderStatus?.value)
      )
    ) {
      return {
        disabled: true,
        tooltip:
          "Selected order must have status: Booked, in Review, Ready For Pickup or Out For Pickup.",
      };
    }
  
    if (!selectedRows.every((row) => row.district === selectedRows[0].district)) {
      return {
        disabled: true,
        tooltip: "All selected order must belong to the same district.",
      };
    }
  
    return {
      disabled: false,
      tooltip: "",
    };
  }

  export function getBulkSamplerAssignStatus(selectedRowMap) {
    const allowedStatusesForBulkSamplerAssign = new Set([
     "pending",
    ]);
    const selectedRows = [...selectedRowMap.values()];
  
    if (selectedRows.length === 0) {
      return {
        disabled: true,
        tooltip: "Please select at least one Order.",
      };
    }
  
    if (selectedRows.some((row) => row.samplerInfo?._id)) {
      return {
        disabled: true,
        tooltip: "Some selected order already assigned Sampler.",
      };
    }
  
    if (
      !selectedRows.every((row) =>
        allowedStatusesForBulkSamplerAssign.has(row.orderStatus?.value)
      )
    ) {
      return {
        disabled: true,
        tooltip:
          "Selected order must have status: Pending.",
      };
    }
  
    if (!selectedRows.every((row) => row.district === selectedRows[0].district)) {
      return {
        disabled: true,
        tooltip: "All selected order must belong to the same district.",
      };
    }
  
    return {
      disabled: false,
      tooltip: "",
    };
  }